module.exports = __webpack_public_path__ + "img/sld_mfm_inv_7_t1_b1_dark.2e6a214d.svg";